import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('../views/Layouts/Main.vue'),
    children: [
      {
        path: '/',
        name: 'RouteBooking',
        meta: {
          authorize: [1, 11],
        },
        component: () => import('../views/Bookings/Index.vue')
      },
      {
        path: '/dashboard',
        name: 'dashboardSale',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/Sales.vue')
      }, 

      {
        path: '/gerencial',
        name: 'RouteGerencial',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/General.vue')
      }, 
      {
        path: '/dashboard-2',
        name: 'dashboardCompaYears',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/YearComparison.vue')
      }, 
      {
        path: '/dashboard-3',
        name: 'dashboardCompaAgents',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/AgentComparison.vue')
      }, 
      {
        path: '/reports/tariff-non-acc',
        name: 'RouteTariffNonAcc',
        meta: {
          authorize: [1],
        },
        component: () => import('../views/Tariff/NonAcc.vue')
      }, 

      {
        path: '/dashboard-4',
        name: 'dashboardCostSuplier',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/CostSupplier.vue')
      },

      {
        path: '/dashboard-5',
        name: 'dashboardCostSrv',
        meta: {
          authorize: [3],
        },
        component: () => import('../views/Dashboard/CostService.vue')
      },

      {
        path: '/reports/cost-and-sale-by-service',
        name: 'RouteCostSaleforService',
        meta: {
          authorize: [5],
        },
        component: () => import('../views/Bookings/CostSaleforService.vue')
      },      
      {
        path: '/reports/sales',
        name: 'RouteSales',
        meta: {
          authorize: [1],
        },
        component: () => import('../views/Sales/Index.vue')
      },
      {
        path: '/reports/booking-analysis',
        name: 'RouteBookAnalysis',
        meta: {
          authorize: [1],
        },
        component: () => import('../views/BookingAnalysis/Index.vue')
      },
      {
        path: '/reports/booking-financials-analysis',
        name: 'RouteBookAnalysis',
        meta: {
          authorize: [5],
        },
        component: () => import('../views/BookingAnalysis/Financials.vue')
      },
      {
        path: '/reports/payment-suppliers',
        name: 'RoutePaymentSuppliers',
        meta: {
          authorize: [5],
        },
        component: () => import('../views/PaymentToSuppliers/Index.vue')
      },
      {
        path: '/reports/accounts-receivable',
        name: 'RouteAccountReceivable',
        meta: {
          authorize: [4],
        },
        component: () => import('../views/AccountsReceivable/Index.vue')
      },
      {
        path: '/reports/stats-locations',
        name: 'RouteStatsLocations',
        meta: {
          authorize: [2],
        },
        component: () => import('../views/Reports/Stats/Locations.vue')
      },
      {
        path: '/reports/stats-serv-types',
        name: 'RouteStatsServTypes',
        meta: {
          authorize: [2],
        },
        component: () => import('../views/Reports/Stats/ServicesTypes.vue')
      },
      {
        path: '/reports/stats-suppliers',
        name: 'RouteStatsSuppliers',
        meta: {
          authorize: [2],
        },
        component: () => import('../views/Reports/Stats/Suppliers.vue')
      },
      {
        path: '/reports/sales-achivied',
        name: 'RouteSalesAchivied',
        meta: {
          authorize: [2],
        },
        component: () => import('../views/Reports/Suppliers/SalesAchivied.vue')
      },
    ]
  },
  {
    path: '',
    component: () => import('../views/Layouts/Auth.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        meta: {},
        component: () => import('../views/Auth/Login.vue')
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if ( savedPosition ) {
      return savedPosition
    } else {
      const position = {} 
      if (to.hash) {
        position.selector = to.hash
        position.behavior = 'smooth'
        if ( document.querySelector(to.hash)) {
          return position
        }
        return false
      }
      return { x: 0, y: 0 }  
    }
  },
  routes
})

export default router

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta;
  let currentUser = localStorage.getItem('asuspausr');
  currentUser = currentUser != null ? JSON.parse(atob(currentUser)) : null;
  if (authorize) {
      if (currentUser == null) {
          return next({ path: '/login'});
      }
      // check if route is restricted by role
      const currentUserAccess = currentUser.accesses; 

      const isAuthorized = currentUserAccess.some(access => authorize.includes(access));

      if (authorize.length && !isAuthorized) {
        // Si no está autorizado, redirigir a la página principal
        return next({ path: '/' });
      }

  }
  next();
})